import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { parseActivity } from 'api/getActivity';

const query = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
      gender
      birthdate
      accounts {
        id
        provider
        providerId
      }
    `;
  return gql`
    query {
      currentActivities {
        id
        state
        channelName
        channelType
        insertedAt
        appealId
        duration
        avatarUrl
        channel {
          type
          identifier
          id
        }
        requestType {
          id
          name
          description
          defaultType
          active
        }
        case {
          id
          name
          description
          insertedAt
          updatedAt
          comment
        }
        customer {
          ${privateCustomerData}
          id
          firstName
          vip
          description
          identified
          customInfo {
            label
            value
          }
        }
        operator {
          id
          name
          firstName
          lastName
          middleName
          avatarUrl
        }
        markers {
          id
          name
          directory {
            id
            name
          }
        }
        messages {
          id
          avatarUrl
          sender
          insertedAt
          body
          isRead
          customerId
          operatorId
          activityId
          receiver
          to
          from
          copies
          auto
          attachments {
            title
            type
            size
            original
            preview
            ext
          }
        }
        isAuthorized
        noAuthorized
      }
    }`;
};

function getCurrentActivities(isExternalOperator = false) {
  return apollo.client.query({
    query: query(isExternalOperator),
    fetchPolicy: 'network-only',
  }).then((res) => res.data.currentActivities.map(parseActivity));
}

export default getCurrentActivities;
